import { database } from "../config"
import { ref, onValue, off } from "firebase/database"
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

const DEFAULT_FLAGS = {
  courses: true,
  maintenance: true,
  organizations: true,
}

export const fetchFlags = createAsyncThunk(
  'flags/fetchFlags',
  async (_, { dispatch, rejectWithValue }) => {
    const flagsRef = ref(database, 'flags_client/')
    dispatch(setLoading(true))
    return new Promise((resolve, reject) => {
      const unsubscribe = onValue(
        flagsRef,
        (snapshot) => {
          const flagsData = snapshot.val()
          dispatch(setFlags(flagsData || DEFAULT_FLAGS))
          dispatch(setLoading(false))
          resolve(flagsData)
        },
        (error) => {
          dispatch(setLoading(false))
          dispatch(setFlags(DEFAULT_FLAGS))
          reject(rejectWithValue("Failed to fetch flags: " + error.message))
        }
      )
      return () => off(flagsRef, "value", unsubscribe)
    })
  }
)

const flagsSlice = createSlice({
  name: "flags",
  initialState: {
    flags: null,
    error: null,
    loading: false,
  },
  reducers: {
    setFlags: (state, action) => {
      state.flags = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFlags.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchFlags.fulfilled, (state) => {
        state.loading = false
        state.error = null
      })
      .addCase(fetchFlags.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
        state.flags = DEFAULT_FLAGS
      })
  },
})

export const { setFlags, setLoading } = flagsSlice.actions
export default flagsSlice.reducer
